import { RefreshCw, TriangleAlert } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { Card, CardContent } from '@/components/ui/card'
import { cn } from '@/lib/utils'

interface ErrorCardProps {
  title?: string
  description?: string
  className?: string
  onRetry?: () => void
}

const ErrorCard = ({
  title = 'Something went wrong',
  description = "We couldn't load this data. Try again.",
  className,
  onRetry,
}: ErrorCardProps) => {
  return (
    <Card className={cn('pt-0', className)}>
      <CardContent className="flex flex-col items-center justify-center gap-4 px-10 py-20 text-center">
        <div
          className="flex size-10 items-center justify-center rounded-full"
          style={{ background: 'var(--red-100)', color: 'var(--red-600)' }}
        >
          <TriangleAlert size={20} />
        </div>
        <div className="flex flex-col items-center gap-2">
          <div className="text-xl font-semibold text-foreground">{title}</div>
          <div className="text-lg text-foreground">{description}</div>
        </div>
        {onRetry && (
          <Button variant="outline" size="sm" onClick={onRetry}>
            <RefreshCw size={14} />
            Try again
          </Button>
        )}
      </CardContent>
    </Card>
  )
}

export default ErrorCard
